import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const BasicInfoIcon = (props: SvgProps) => (
  <Svg width={299} height={262} fill="none" {...props}>
    <Path
      stroke="#C0A46F"
      strokeWidth={1.5}
      d="M0 261c47.333-5.667 171.48-23.396 207.5-82.747 44-72.5-15-60.5-15-33.5-19-20.5-43.972-15.445-34 4.5 9.5 19 46.5 68.5 110 14 46.54-39.944 42.05-103.255-43-162.373"
    />
  </Svg>
);
export default BasicInfoIcon;
